module.exports = __webpack_public_path__ + "img/20161119_104732-1.f754a639.jpg";